
import barba from '@barba/core';
import anime from 'animejs';

export default class{

	constructor(){
        this.drawerLinks = []
        this.opened = false

        this.opening_class = 'drawer-opening'
        this.opened_class = 'drawer-opened'
        this.closing_class = 'drawer-closing'
        
        this.hamburger_id = "#js-hamburger"
        this.drawer_id = "#js-drawer"
        this.drawer_link_class = ".js-drawer__nav--link"
        this.drawer_str_class = ".l-drawer__nav--str"

        this.drawer_img_id = "#js-drawer__image--elem"

        this.logo = '#l-header__logo a'

        barba.hooks.once((data) => {
            this.init()
        })
        barba.hooks.after((data) => {
            this.init()
        });
    }

    init(){
        this.body = document.body;
        this.hamburger = document.querySelector(this.hamburger_id);
        this.drawer = document.querySelector(this.drawer_id);
        this.drawerImg = document.querySelector(this.drawer_img_id)
        this.headerLogo = document.querySelector(this.logo);
        if(this.drawer){
            this.drawerLinks = this.drawer.querySelectorAll(this.drawer_link_class);
            if(this.hamburger){
                this.hamburger.addEventListener('click',(e) => {
                    this.drawerClick(e);
                })
            }
            if(this.drawerLinks){
                if( this.drawerLinks.length > 0 ){
                    this.drawerLinks.forEach( (drawerLink) => {
                        this.drawerRemoveClass(drawerLink)
                    });
                }
            }
            if(this.drawerImg) {
                this.setHoverEvent(this.drawerImg, this.drawerLinks);
            }
            if(this.headerLogo) {
                this.drawerRemoveClass(this.headerLogo)
            }
            
        }
        
    }
    drawerClick(e){
            
        this.drawerToggleClass();
    }
    drawerToggleClass(){
        if(!this.opened){
           this.open();
            
        }else{
            this.close();
        }
    }
    drawerRemoveClass(drawerLink){
        drawerLink.addEventListener('click',() =>{
            setTimeout(() =>{
                this.close();
            },300)
        })
    } 
    open(){
        this.body.classList.add(this.opening_class);
        this.body.classList.add(this.opened_class);
        this.hamburger.setAttribute('aria-expanded',true)
        anime({
            targets:this.drawer_str_class,
            translateY:['100%',0],
            opacity:[0,1],
            easing: 'easeInOutSine',
            duration:500,
            delay:function(el,i){
                return i * 20;
            }
        })
        this.opened = true;

    }
    close (){
        this.body.classList.remove(this.opening_class);
        this.body.classList.add(this.closing_class);
        this.hamburger.setAttribute('aria-expanded',false)
        setTimeout(() =>{
            this.drawer.scrollTop =  0;
            this.body.classList.remove(this.closing_class);
            this.body.classList.remove(this.opened_class);
            this.body.classList.remove(this.opening_class);
            this.opened = false;
            this.drawerImg.style.backgroundImage = "url(/dist/img/drawer/drawer-home.jpg)";
        },400)
    }
    setHoverEvent(elem, items) {
        if(items.length > 0) {
            items.forEach( (item) => {
                let bg = item.getAttribute('data-drawer')
                this.hoverEvent(elem, item, bg)
            });
        }
    }
    hoverEvent(elem, link, bg) {
        link.addEventListener('mouseenter', () => {
            let current = elem.style.backgroundImage.slice(4, -1).replace(/"/g, "");
            if(bg === current) {
                return false;
            }
            let image = new Image();
            image.src = bg;
            image.onload = function () {
                let drawerBg_animation = anime.timeline();
                drawerBg_animation.add({
                    targets: elem,
                    opacity:[1,0],
                    easing: "easeOutExpo",
                    duration:360,
                    complete : () => {
                        elem.style.backgroundImage = "url(" + bg + ")";
                    }
                })
                drawerBg_animation.add({
                    targets: elem,
                    opacity:[0,1],
                    easing: "easeOutExpo",
                    duration:360
                })
            }
        })
    }
}